require("core-js/modules/es6.regexp.search");

var _require = require('url'),
    parse = _require.parse;

var qsMerge = require('qs-merge');

var qsAdd = function qsAdd(add) {
  return function (uri) {
    var parsed = parse(uri || "", true);
    var query = qsMerge(add)(parsed.query);
    parsed.search = query ? "?".concat(query) : "";
    return parsed.format();
  };
};

module.exports = qsAdd;